<template>
  <q-dialog persistent v-model="isImportModalOpen">
    <q-card style="max-width: 400px; width: 100%" v-if="!isImported && data === null">
      <h3>Import from excel</h3>
      <q-form @submit.prevent="importExcel">
        <div class="q-pa-md">
          <div class="row q-col-gutter-md">
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <span class="label-input">File *</span>
              <div class="file-input">
                <input ref="fileInput" required accept=".xlsx, .xls" @change="selectFile" type="file" class="file"/>
                <label for="file">
                  <q-icon class="q-mx-sm" name="fas fa-upload" size="20px" color="grey-7"></q-icon>
                  File*
                  <span class="file-name"></span
                  ></label>
              </div>
              <p>{{ fileName }}</p>
            </div>
            <div class="col-12">
              <div class="mt-5 flex-end q-gutter-xs">
                <q-btn color="grey-7" v-close-popup>CANCEL</q-btn>
                <q-btn :loading="isImporting" label="Upload" type="submit" color="positive">
                  <template v-slot:loading>
                    <q-spinner-facebook/>
                  </template>
                </q-btn>
              </div>
            </div>
          </div>
        </div>
      </q-form>
    </q-card>
    <q-card style="max-width: 960px; width: 100%" v-else>
      <h3>Import from excel</h3>
      <div style="margin-bottom: 15px;" v-if="data.items.length > 0">
        <h4 style="color: green;">Suitable vehicles</h4>
        <table>
          <thead>
          <tr>
            <th>VIN</th>
            <th>Mileage</th>
            <th>Condition Grade</th>
            <th>State Code</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in data.items">
            <td>{{ item.vin }}</td>
            <td>{{ toNumberFormat(item.mileage) }}</td>
            <td>{{ item.grade ?? '-' }}</td>
            <td>{{ item.state }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div style="margin-bottom: 15px;" v-if="data.errors.length > 0">
        <h4 style="color: red;">Unsuitable vehicles</h4>
        <table>
          <thead>
          <tr>
            <th>VIN</th>
            <th>Reason</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="error in data.errors">
            <td>{{ error.vin }}</td>
            <td>{{ error.message }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="flex justify-end q-pa-md">
        <q-btn color="red" label="Cancel" class="q-mr-md" v-close-popup @click="close"/>
        <q-btn color="positive" label="Import" v-close-popup @click="importItems"/>
      </div>
    </q-card>
  </q-dialog>
</template>

<script>
import axios from '../axios/index'
import {routes} from "@/components/blackbook/routes";
import toCurrency from "../helper/toCurrency";
import toNumberFormat from "../helper/toNumberFormat";

export default {
  data() {
    return {
      file: null,
      fileName: '',
      isImporting: false,
      isImported: false,
      data: null,
    }
  },
  computed: {
    isImportModalOpen: {
      get() {
        return this.$store.state.blackbook.isImportModalOpen
      },
      set(val) {
        this.$store.commit('blackbook/SET_IS_IMPORT_MODAL', val)
      }
    },
    selectedItems: {
      get() {
        return this.$store.state.blackbook.selectedItems
      },
      set(val) {
        this.$store.commit('blackbook/SET_SELECTED_ITEMS', val)
      }
    },
    route: {
      get() {
        return this.$store.state.blackbook.route
      },
      set(val) {
        this.$store.commit('blackbook/SET_ROUTE', val)
      }
    },
  },
  methods: {
    toNumberFormat,
    toCurrency,
    selectFile() {
      this.file = this.$refs.fileInput.files[0]
      this.fileName = this.file.name
    },
    async importExcel() {
      try {
        this.isImporting = true
        const formData = new FormData()
        formData.append('file', this.file)

        const {data} = await axios.post('/blackbook/import-excel', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: localStorage.getItem('token')
          }
        })
        this.data = data.data
        this.file = null
        this.isImported = true
      } catch (error) {
        this.$q.notify({
          message: error.message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
        this.file = null
      } finally {
        this.isImporting = false
      }
    },
    async importItems() {
      this.isImporting = true
      this.data.items.forEach(item => {
        let vehicle_condition_grade
        try {
          vehicle_condition_grade = item.vehicle.last_mileage_record?.market_values[0].condition_grade
        } catch (e) {
          vehicle_condition_grade = null
        }

        let auction = 0
        try {
          auction = item.vehicle.last_mileage_record.market_values[0].price
        } catch (e) {
          auction = 0
        }

        const data = {
          id: item.vehicle.id,
          vin: item.vin,
          unit: item.vehicle.unit,
          group: item.vehicle.group_name,
          class: item.vehicle.class_name,
          make: item.vehicle.brand?.name,
          model: item.vehicle.model?.name,
          model_detail: item.vehicle.model_detail?.name,
          model_year: item.vehicle.model_year,
          color: item.vehicle.color,
          condition: item.vehicle.condition,
          mileage: item.mileage ?? item.vehicle.last_mileage_record?.mileage,
          grade: item.grade ?? vehicle_condition_grade,
          state: item.state ?? item.vehicle.company.state?.code,
          company: item.vehicle.company,
          location: item.vehicle.location,
          excellent_revenue: item.vehicle.finance?.calculated_values[0]?.excellent_profit,
          good_revenue: item.vehicle.finance?.calculated_values[0]?.good_profit,
          fair_revenue: item.vehicle.finance?.calculated_values[0]?.fair_profit,
          payoff: item.vehicle.finance?.payoff,
          auction: auction,
          purchase_amount: item.finance?.purchase_amount,
          last_mileage_record: item.vehicle.last_mileage_record,
        }
        const index = this.selectedItems.findIndex(selectedItem => selectedItem.id === data.id)
        if (index !== -1) {
          this.selectedItems.splice(index, 1, data)
        } else {
          this.selectedItems.push(data)
        }
      })

      this.$q.notify({
        message: 'Vehicles imported successfully',
        timeout: 250,
        position: 'top-right',
        progress: true,
        type: 'positive'
      });
      this.route = routes.selectionList
      this.isImporting = false
      this.close()
    },
    close() {
      this.isImported = false
      this.data = null
      this.isImportModalOpen = false
    },
  }
}
</script>

<style scoped>
h3 {
  margin: 0 0 15px;
  padding: 10px 15px;
  font-size: 16px;
  line-height: 16px;
  background-color: #e0e0e0;
  border-bottom: 1px solid #f2f2f2;
}

h4 {
  margin: 15px;
  padding: 0;
  font-size: 14px;
  line-height: 14px;
}

.file-input {
  position: relative;
  height: 56px;
  width: 100%;
  cursor: pointer;
}

.file {
  opacity: 0;
  width: 100%;
  height: 56px;
  left: 0;
  top: 0;
  position: absolute;
  z-index: 1000;
  outline: none;
  cursor: pointer;
}

.file-input label {
  display: flex;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.24);
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  color: #bdbdbd;
  font-weight: bold;
  transition: transform 0.2s ease-out;
  cursor: pointer;
}

input:hover + label {
  cursor: pointer;
  background: rgb(189, 189, 189, 0.2);
}

table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e0e0e0;
}

table th, td {
  padding: 5px 10px;
  border: 1px solid #e0e0e0;
  cursor: auto !important;
}
</style>
